import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Check } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-gradient-to-r from-green-50 to-emerald-50" data-id="element-116">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-xl p-8 sm:p-12 text-center" data-id="element-118">
          <div className="flex justify-center mb-6" data-id="element-119">
            <div className="bg-green-100 rounded-full p-6" data-id="element-120">
              <Shield className="w-16 h-16 text-green-600" data-id="element-121" />
            </div>
          </div>

          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6" data-id="element-122">
            🛡️ GARANTÍA TOTAL DE 7 DÍAS
          </h2>

          <p className="text-xl text-gray-700 mb-6" data-id="element-123">
            Usá el sistema durante una semana completa.
          </p>

          <p className="text-lg text-gray-700 mb-4" data-id="element-124">Si no sentís:</p>

          <ul className="text-left max-w-2xl mx-auto space-y-3 mb-8" data-id="element-125">
            {['Una diferencia real en la organización de tus sesiones', 'Más seguridad clínica al entrar al consultorio', 'Menos tiempo preparando material fuera de hora'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-126">
                <Check className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-127" />
                <span className="text-gray-700 text-lg" data-id="element-128">{item}</span>
              </li>)}
          </ul>

          <p className="text-2xl font-bold text-green-700 mb-4" data-id="element-129">
            Te devolvemos el 100% del dinero.
          </p>

          <p className="text-lg text-gray-600" data-id="element-130">
            Sin preguntas. Sin formularios. Sin vueltas.
          </p>
        </motion.div>
      </div>
    </section>;
}